import type React from "react";

import { SkeletonLayout } from "shared/atoms/SkeletonLayout";

export const CommissionRatesSkeleton: React.FC = () => (
  <SkeletonLayout
    layout={{
      type: "column",
      spacing: 2,
      children: [
        {
          type: "row",
          spacing: 2,
          alignItems: "center",
          justifyContent: "space-between",
          children: [
            { type: "skeleton", variant: "text", typographyVariant: "subtitle2", width: "40%" },
            {
              type: "skeleton",
              variant: "rounded",
              width: 50,
              height: 40,
            },
          ],
        },
        { type: "skeleton", variant: "rounded", width: "100%", height: 30 },
        { type: "skeleton", variant: "rounded", width: "100%", height: 40 },
      ],
    }}
  />
);
